export var version = '3.3.12';
//# sourceMappingURL=version.js.map